module.exports = __webpack_public_path__ + "static/media/settinggg.c71a93f7.svg";